import { render, staticRenderFns } from "./MultiplesProducts.vue?vue&type=template&id=c859b140&scoped=true"
import script from "./MultiplesProducts.vue?vue&type=script&lang=js"
export * from "./MultiplesProducts.vue?vue&type=script&lang=js"
import style0 from "./MultiplesProducts.vue?vue&type=style&index=0&id=c859b140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c859b140",
  null
  
)

export default component.exports